<div class="d-flex mt-2 row">
  <mat-form-field appearance="outline" class="col-md-4">
    <mat-label>Enter week date range</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate [(ngModel)]="startDate" placeholder="Start date">
      <input matEndDate [(ngModel)]="endDate" placeholder="End date">
    </mat-date-range-input>
    <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>

<!--  <mat-form-field appearance="outline" class="col-md-6">-->
<!--    <mat-label>Select Centre</mat-label>-->
<!--    <mat-select #selectElement [(ngModel)]="selectedCentreCode" multiple>-->
<!--      <app-select-all [matSelect]="selectElement"></app-select-all>-->
<!--      <mat-option *ngFor=" let c of (centres$|async) "-->
<!--                  [value]="c.centreCode">{{ c.centreName }}-->
<!--      </mat-option>-->
<!--    </mat-select>-->
<!--  </mat-form-field>-->


  <app-searchable-select
    class="col-md-4"
    [options]="centres$ | async"
    [selectedValue]="selectedCentre"
    [displayWithFn]="displayCentre"
    [placeholder]="'Select Centre'"
    [label]="'Select Centre'"
    [multiple]="true"
    (selectionChange)="onCentreSelect($event)">
  </app-searchable-select>

  <div class="col-md-2">
    <button mat-mini-fab (click)="SearchData()" color="accent" permission="Daily Child Report" [permissionTypes]="[PermissionType.ALL, PermissionType.VIEW]">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab (click)="clearAll()" color="accent" style="margin-left: 10px;">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</div>
<div class="d-flex flex-wrap">
  <mat-card class="col-md-12 col-sm-12 mb-4">
    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Daily Occupancy Report</h2>
        </li>
        <li class="dropdown m-l-20">
          <label for="search-input"><i class="material-icons search-icon">search</i></label>
          <input placeholder="Search" type="text" id="search-input" class="browser-default search-field"
                 (keyup)='applyFilter($event)' aria-label="Search box" #input>
        </li>
      </ul>
      <ul class="header-buttons mr-2">

        <li>
          <div class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Daily Child Report" [permissionTypes]="[PermissionType.ALL, PermissionType.ADD]" >
            <img src="../../../../../assets/images/icons/xlsx.png" alt=""/>
          </div>
        </li>
      </ul>
    </div>
    <table mat-table [dataSource]="dataSource" matSort id="DailyOccupancyReportTable">
      <!-- Sr Column -->
      <ng-container matColumnDef="Sr">
        <th mat-header-cell *matHeaderCellDef> Sr</th>
        <td mat-cell *matCellDef="let element; let i = index" class="vertical-top"> {{ i + 1 }}</td>
      </ng-container>

      <!-- Centre Name Column -->
      <ng-container matColumnDef="centreName">
        <th mat-header-cell *matHeaderCellDef> Centre Name</th>
        <td mat-cell *matCellDef="let element" class="vertical-top"> {{ getCentreNameByCode(element.centreCode) }}</td>
      </ng-container>
      <ng-container matColumnDef="childDetails">
        <th mat-header-cell *matHeaderCellDef> Child Details</th>
        <td mat-cell *matCellDef="let element">
          <table mat-table [dataSource]="element.children" class="child-table">
            <!-- Sr. No Column -->
            <ng-container matColumnDef="srNo">
              <th mat-header-cell *matHeaderCellDef> Sr. No.</th>
              <td mat-cell *matCellDef="let child; let i = index">
                {{ i + 1 }}
              </td>
            </ng-container>

            <!-- Child Details Column -->
            <ng-container matColumnDef="childName">
              <th mat-header-cell *matHeaderCellDef> Child Name</th>
              <td mat-cell *matCellDef="let child">
                {{ child.firstName }} {{ child.lastName }}
              </td>
            </ng-container>
            <!-- Child Details Column -->
            <ng-container matColumnDef="childCode">
              <th mat-header-cell *matHeaderCellDef> Child Code</th>
              <td mat-cell *matCellDef="let child">
                {{ child.childCode }}
              </td>
            </ng-container>
            <ng-container matColumnDef="currentUnit">
              <th mat-header-cell *matHeaderCellDef> Child Unit</th>
              <td mat-cell *matCellDef="let child">
                {{ child?.unit }}
              </td>
            </ng-container>

            <!-- Define the table structure -->
            <tr mat-header-row *matHeaderRowDef="['srNo', 'childName','childCode','currentUnit']"></tr>
            <tr mat-row *matRowDef="let row; columns: ['srNo', 'childName','childCode','currentUnit'];"></tr>
          </table>
        </td>
      </ng-container>
      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef> Date</th>
        <td mat-cell *matCellDef="let element" class="vertical-top"> {{ element.date.toDate() | date:'dd/MM/yyyy' }}
        </td>
      </ng-container>
      <!-- Table Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[25, 50, 100,200]" aria-label="Select page of users"></mat-paginator>
  </mat-card>
</div>
